import { useRef } from 'react';
import { resolveSwipe } from '../lib/swipe';

/**
 * Banner slider'larına parmakla sağa/sola kaydırma ekler. Dönen nesne
 * doğrudan kaydırılacak konteynere yayılır:
 *
 *   const swipe = useSwipe({ enabled: count > 1, onNext, onPrev });
 *   <div className="hero-slider" {...swipe}>
 *
 * İki bilinçli karar var:
 *
 * - `touchmove` **preventDefault etmez.** Jestin yatay olduğuna ancak parmak
 *   kalkınca karar verilir; hareketi erken engellemek mobilde sayfanın dikey
 *   kaydırmasını banner'ın üstünde kilitlerdi. Yatay jesti tarayıcıdan
 *   devralmak için konteynerin CSS'inde `touch-action: pan-y` durur.
 * - Kaydırma bittiğinde tarayıcı yine de bir `click` üretebilir; banner bir
 *   bağlantı olduğu için kaydırma sayfayı açardı. Bu yüzden kaydırma
 *   algılandığı turda tıklama yakalama aşamasında düşürülür.
 */
const useSwipe = ({ onNext, onPrev, enabled = true, minDistance, ratio } = {}) => {
  const start = useRef(null);
  const swiped = useRef(false);

  const onTouchStart = (event) => {
    // Çok parmaklı jest (yakınlaştırma) kaydırma değildir.
    if (!enabled || event.touches.length !== 1) {
      start.current = null;
      return;
    }
    const touch = event.touches[0];
    start.current = { x: touch.clientX, y: touch.clientY };
    swiped.current = false;
  };

  const onTouchMove = (event) => {
    if (event.touches.length > 1) start.current = null;
  };

  const onTouchEnd = (event) => {
    const from = start.current;
    start.current = null;
    if (!from) return;
    const touch = event.changedTouches && event.changedTouches[0];
    if (!touch) return;

    const direction = resolveSwipe(
      from,
      { x: touch.clientX, y: touch.clientY },
      { minDistance, ratio },
    );
    if (!direction) return;

    swiped.current = true;
    if (direction === 'left') {
      if (onNext) onNext();
    } else if (onPrev) {
      onPrev();
    }
  };

  const onTouchCancel = () => {
    start.current = null;
  };

  const onClickCapture = (event) => {
    if (!swiped.current) return;
    swiped.current = false;
    event.preventDefault();
    event.stopPropagation();
  };

  return { onTouchStart, onTouchMove, onTouchEnd, onTouchCancel, onClickCapture };
};

export default useSwipe;
